import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  // 'ReplaySubject' passing '1' ensures that
  // subscriber subscribe to the latest 'err'
  // even if subscriber's component is created
  // after 'err' is emitted from 'next'.
  error$ = new ReplaySubject<Error>(1);

  emitError(err) {
    this.error$.next(err);
  }
}
